import { render, staticRenderFns } from "./expenditure-income.vue?vue&type=template&id=413944cb&scoped=true&"
import script from "./expenditure-income.vue?vue&type=script&lang=js&"
export * from "./expenditure-income.vue?vue&type=script&lang=js&"
import style0 from "./expenditure-income.vue?vue&type=style&index=0&id=413944cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413944cb",
  null
  
)

export default component.exports